// Theme Configuration for Multi-Regional Deployment

export const themes = {
  green: {
    name: 'North America',
    region: 'NA',
    colors: {
      // Primary colors
      primary: '#10b981',
      primaryDark: '#059669',
      primaryLight: '#34d399',
      secondary: '#6ee7b7',
      accent: '#047857',
      
      // Gradients
      mainGradient: 'linear-gradient(135deg, #064e3b 0%, #065f46 25%, #047857 50%, #059669 75%, #10b981 100%)',
      cardGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(5, 150, 105, 0.1) 100%)',
      buttonGradient: 'linear-gradient(135deg, #059669 0%, #10b981 50%, #34d399 100%)',
      glowGradient: 'linear-gradient(135deg, #6ee7b7 0%, #a7f3d0 50%, #d1fae5 100%)',
      
      // Text colors
      textPrimary: '#d1fae5',
      textSecondary: '#a7f3d0',
      textTertiary: '#6ee7b7',
      textLight: '#ecfdf5',
      
      // Background colors
      bgOverlay: 'rgba(16, 185, 129, 0.1)',
      bgCard: 'rgba(255, 255, 255, 0.05)',
      bgHover: 'rgba(16, 185, 129, 0.15)',
      
      // Border colors
      borderPrimary: 'rgba(16, 185, 129, 0.3)',
      borderSecondary: 'rgba(16, 185, 129, 0.2)',
      
      // Shadow colors
      shadowPrimary: 'rgba(16, 185, 129, 0.4)',
      shadowSecondary: 'rgba(16, 185, 129, 0.2)',
      
      // Special colors
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6'
    }
  },
  
  purple: {
    name: 'Asia Pacific',
    region: 'AP',
    colors: {
      // Primary colors
      primary: '#a855f7',
      primaryDark: '#8b5cf6',
      primaryLight: '#c084fc',
      secondary: '#e9d5ff',
      accent: '#7c3aed',
      
      // Gradients
      mainGradient: 'linear-gradient(135deg, #1a0b2e 0%, #2d1b4e 25%, #4a2c6d 50%, #6b3d8f 75%, #8e4ec6 100%)',
      cardGradient: 'linear-gradient(135deg, rgba(168, 85, 247, 0.15) 0%, rgba(147, 51, 234, 0.1) 100%)',
      buttonGradient: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 50%, #c084fc 100%)',
      glowGradient: 'linear-gradient(135deg, #e9d5ff 0%, #f3e8ff 50%, #fae8ff 100%)',
      
      // Text colors
      textPrimary: '#fae8ff',
      textSecondary: '#f3e8ff',
      textTertiary: '#e9d5ff',
      textLight: '#c4b5fd',
      
      // Background colors
      bgOverlay: 'rgba(168, 85, 247, 0.1)',
      bgCard: 'rgba(255, 255, 255, 0.05)',
      bgHover: 'rgba(168, 85, 247, 0.15)',
      
      // Border colors
      borderPrimary: 'rgba(168, 85, 247, 0.3)',
      borderSecondary: 'rgba(168, 85, 247, 0.2)',
      
      // Shadow colors
      shadowPrimary: 'rgba(138, 43, 226, 0.4)',
      shadowSecondary: 'rgba(138, 43, 226, 0.2)',
      
      // Special colors
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6'
    }
  },
  
  pink: {
    name: 'Wellbeing',
    region: 'WB',
    colors: {
      // Primary colors
      primary: '#ec4899',
      primaryDark: '#db2777',
      primaryLight: '#f472b6',
      secondary: '#fce7f3',
      accent: '#be185d',
      
      // Gradients
      mainGradient: 'linear-gradient(135deg, #500724 0%, #831843 25%, #be185d 50%, #db2777 75%, #ec4899 100%)',
      cardGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.15) 0%, rgba(219, 39, 119, 0.1) 100%)',
      buttonGradient: 'linear-gradient(135deg, #db2777 0%, #ec4899 50%, #f472b6 100%)',
      glowGradient: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 50%, #f9a8d4 100%)',
      
      // Text colors
      textPrimary: '#fce7f3',
      textSecondary: '#fbcfe8',
      textTertiary: '#f9a8d4',
      textLight: '#f472b6',
      
      // Background colors
      bgOverlay: 'rgba(236, 72, 153, 0.1)',
      bgCard: 'rgba(255, 255, 255, 0.05)',
      bgHover: 'rgba(236, 72, 153, 0.15)',
      
      // Border colors
      borderPrimary: 'rgba(236, 72, 153, 0.3)',
      borderSecondary: 'rgba(236, 72, 153, 0.2)',
      
      // Shadow colors
      shadowPrimary: 'rgba(219, 39, 119, 0.4)',
      shadowSecondary: 'rgba(219, 39, 119, 0.2)',
      
      // Special colors
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6'
    }
  }
};

// Helper function to get theme by name
export const getTheme = (themeName = 'purple') => {
  return themes[themeName] || themes.purple;
};

// Helper function to apply theme CSS variables
export const applyTheme = (theme) => {
  const root = document.documentElement;
  
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
};

export default themes;